<div class="container">
  <div style="height: 120px">
    <mat-icon class="graphic" svgIcon="unauthorized"></mat-icon>
  </div>
  <div class="page-title">{{'error.unauthorized' | translate}}</div>
</div>
